<div *ngIf="muro && participo" [class.blur-strong]="misdatos.perfilPublico == 'no_publico'">
  <div *ngIf="muro.rs_id == 0 && !muro.showeditar">
    <section class="iguau-composer iguau-composer-closed mb-3" aria-label="Crear publicación">
      <div class="ig-compose-prompt-row">
        <img [src]="misdatos?.foto?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
          class="ig-compose-avatar" [alt]="'Foto de ' + (misdatos?.first_name || 'usuario')" />
        <button type="button" class="ig-compose-prompt" (click)="editarPublicacion(true)">
          Hola {{misdatos.first_name | firstWord}}, ¿qué te gustaría compartir?
        </button>
      </div>
      <div class="ig-compose-quick" aria-label="Accesos rápidos para publicar">
        <button type="button" (click)="editarPublicacion(true, '')" class="ig-compose-quick-action"><i class="fa-regular fa-image" aria-hidden="true"></i><span>Publicación</span></button>
        <button type="button" (click)="editarPublicacion(true, '01')" class="ig-compose-quick-action"><i class="fa-solid fa-person-walking" aria-hidden="true"></i><span>Paseo</span></button>
        <button type="button" (click)="editarPublicacion(true, '02')" class="ig-compose-quick-action"><i class="fa-solid fa-hand-holding-heart" aria-hidden="true"></i><span>Servicio</span></button>
        <button type="button" (click)="editarPublicacion(true, '03')" class="ig-compose-quick-action"><i class="fa-solid fa-chart-simple" aria-hidden="true"></i><span>Encuesta</span></button>
      </div>
    </section>
  </div>
  <div *ngIf="muro.showeditar" [ngClass]="{'iguau-composer iguau-composer-editor mb-3' : muro.rs_id == 0 && !muro.comentario}">
    <div class="d-flex">
      <div class="me-2" *ngIf="muro.rs_id == 0">
        <img *ngIf="misdatos?.foto?.foto_principal_thumb" 
              [src]="misdatos?.foto?.foto_principal_thumb" class="rounded-circle pointer" width="40" alt="Foto de perfil">
      </div>
      <div class="w-100 ig-compose-edit-body">
        <div class="ig-compose-editor-heading" *ngIf="muro.rs_id == 0 && muro.nivel == 0">
          <div><strong>Crear publicación</strong><span>Comparte novedades, fotos y momentos con la comunidad</span></div>
          <i class="fa-solid fa-paw" aria-hidden="true"></i>
        </div>
        <div class="row mb-2 ig-compose-settings" *ngIf="muro.nivel == 0">
          <div class="col-auto">
            <label for="rs_tipo_publicacion" class="form-label">Tipo de publicación</label>
            <select id="tipopublicacion" class="form-select" [(ngModel)]="muro.rs_tipo_publicacion">
              <option *ngFor="let publicacion of tipopublicaciones" [value]="publicacion.va_id">{{ publicacion.va_nombre }}</option>
            </select>
          </div>
          <div class="col">
            <label for="rs_ma_id" class="form-label">Quién</label>
            <select id="mascota" class="form-select" [(ngModel)]="muro.rs_ma_id">
              <option value="" [value]="0">Yo</option>
              <option *ngFor="let mascota of mascotas" [value]="mascota.ma_id">{{ mascota.ma_nombre }}</option>
            </select>
          </div>
          <div class="col-auto">
            <label for="rs_alcance" class="form-label">Alcance</label>
            <select id="alcance" class="form-select" [(ngModel)]="muro.rs_alcance">
              <option value="" [value]="">Solo para amigos</option>
              <option value="1" [value]="1">Solo para mí</option>
              <option value="2" [value]="2">Para todo el mundo</option>
            </select>
          </div>
        </div>
        <!--TEXTO-->
        <div class="row">
          <div class="col">
            <label for="rs_texto" class="form-label">¿Qué quieres contar?</label>
            <textarea id="rs_texto" #publicarTextarea class="form-control mb-2 ig-compose-textarea" rows="3" placeholder="Escribe algo bonito para compartir con la comunidad..." [(ngModel)]="muro.rs_texto"></textarea>
          </div>
        </div>
        <!--TIPOS DE PUBLICACIÓN-->
        <!--PASEO-->
        <div class="row" *ngIf="muro.rs_tipo_publicacion == '01' && muro.nivel == 0">
          <div class="col-auto mb-2">
            <label for="rsp_fecha" class="form-label">Fecha del paseo</label>
            <input type="date" class="form-control" [(ngModel)]="muro.paseo!.rsp_fecha">
          </div>
          <div class="col-auto mb-2">
            <label for="rsp_hora" class="form-label">Hora del paseo</label>
            <input type="time" class="form-control" [(ngModel)]="muro.paseo!.rsp_hora">
          </div>
          <div class="col-12 col-sm-12 col-md mb-2">
            <label for="rsp_ubicacion" class="form-label">Lugar del paseo</label>
            <input type="text" class="form-control" placeholder="Lugar del paseo" [(ngModel)]="muro.paseo!.rsp_ubicacion">
          </div>
        </div>
        <!--SERVICIO-->
        <div class="row" *ngIf="muro.rs_tipo_publicacion == '02' && muro.nivel == 0">
          <div class="col-auto mb-2">
            <label for="rsse_tipo" class="form-label">Tipo de servicio</label>
            <select id="rsse_tipo" class="form-select" [(ngModel)]="muro.servicio!.rsse_tipo">
              <option value="" [value]="">Selecciona el tipo de servicio</option>
              <option *ngFor="let servicio of tiposervicios" [value]="servicio.va_id">{{ servicio.va_nombre }}</option>
            </select>
          </div>
          <div class="col-auto mb-2">
            <label for="rsse_rol" class="form-label">Tu rol</label>
            <select id="rsse_rol" class="form-select" [(ngModel)]="muro.servicio!.rsse_rol">
              <option value="" [value]="">Selecciona tu rol</option>
              <option value="1" [value]="1">Ofrezco el servicio</option>
              <option value="2" [value]="2">Busco el servicio</option>
            </select>
          </div>
        </div>
        <!--ENCUESTA-->
        <div class="mb-3" *ngIf="muro.rs_tipo_publicacion == '03' && muro.nivel == 0">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col mb-2">
                  <label for="rse_pregunta" class="form-label">Pregunta</label>
                  <input type="text" class="form-control" placeholder="Pregunta de la encuenta" [(ngModel)]="pregunta_encuesta!.rse_pregunta">
                </div>
                <div class="col-auto mb-2">
                  <label for="rse_tipo" class="form-label">Tipo</label>
                  <select id="rse_tipo" class="form-select" [(ngModel)]="pregunta_encuesta!.rse_tipo">
                    <option value="" [value]="">Tipo de pregunta</option>
                    <option *ngFor="let encuesta of tipoencuestas" [value]="encuesta.va_id">{{ encuesta.va_nombre }}</option>
                  </select>
                </div>
              </div>
              <!--MULTIPLE-->
              <div class="row" *ngIf="pregunta_encuesta.rse_tipo == '02'">
                <div class="col-auto mb-2" *ngFor="let i of [1,2,3,4]">
                  <label [for]="'rse_respuesta_' + i" class="form-label">Respuesta {{ i }}</label>
                  <input
                    type="text"
                    class="form-control"
                    [placeholder]="'Respuesta ' + i"
                    [id]="'rse_respuesta_' + i"
                    [ngModel]="getRespuesta(i)"
                    [maxChars]="50"
                    (ngModelChange)="setRespuesta(i, $event)">
                </div>
              </div>
            </div>
            <div class="col-auto mb-2 mt-auto">
              <button class="btn btn-sm btn-primary" (click)="addPregunta()"><i class="fa-solid fa-plus"></i></button>
            </div>
          </div>
          <div class="row poll-details mb-2" *ngFor="let pregunta of muro.encuesta">
            <div class="col" [class.disabled-div]="pregunta.rse_borrado">
              {{pregunta.rse_pregunta}}
              <!--Multiple-->
              <div *ngIf="pregunta.rse_tipo == '02'">
                <div class="row">
                  <div class="col-auto mb-2">{{pregunta.rse_respuesta_1}}</div>
                  <div class="col-auto mb-2">{{pregunta.rse_respuesta_2}}</div>
                  <div class="col-auto mb-2">{{pregunta.rse_respuesta_3}}</div>
                  <div class="col-auto mb-2">{{pregunta.rse_respuesta_4}}</div>
                </div>
              </div>
            </div>
            <div class="col-auto" [class.disabled-div]="pregunta.rse_borrado">{{pregunta.va_nombre}}</div>
            <div class="col-auto" title="Borrar" *ngIf="!pregunta.rse_borrado"><div class=" custom-link" (click)="pregunta.rse_borrado = !pregunta.rse_borrado"><i class="fa-regular fa-trash-can"></i></div></div>
            <div class="col-auto" title="Recuperar" *ngIf="pregunta.rse_borrado"><div class=" custom-link" (click)="pregunta.rse_borrado = !pregunta.rse_borrado"><i class="fa-solid fa-rotate-left"></i></div></div>
          </div>
        </div>
        <!--Fotos-->
        <div class="row align-items-end ig-compose-photos">
          <div class="col">
            <label class="form-label"><i class="fa-regular fa-images me-2"></i>Fotografías</label>
            <p class="ig-compose-photos-help">Añade imágenes para dar vida a tu publicación.</p>
            <div class="row">
              <div class="col-auto div-delete mb-1 ig-compose-photo" *ngFor="let foto of muro.previewUrl; let i = index">
                <!-- Botón papelera flotante -->
                <span *ngIf="!foto.borrada" class="btn-delete" (click)="borrarFoto(i)">
                  <i class="fa-solid fa-trash small" title="Borrar foto"></i>
                </span>
                <span *ngIf="foto.borrada" class="btn-delete" (click)="borrarFoto(i)">
                  <i class="fa-solid fa-arrow-rotate-right" title="Recuperar foto"></i>
                </span>
                <img [src]="(foto.data == '') ? foto.url : foto.data" class="rounded pointer" width="80" alt="Fotos"
                    [ngClass]="{'disabled-div': foto.borrada}"
                    (click)="onClickImagen()">
              </div>
              <div class="col-auto">
                <button type="button" class="add-photo-box ig-compose-photo-add" (click)="onClickImagen()" title="Añadir fotografía" aria-label="Añadir fotografía">
                  <i class="fa-solid fa-plus" aria-hidden="true"></i>
                  <span>Añadir</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ig-compose-footer">
          <span class="ig-compose-footer-note"><i class="fa-solid fa-shield-heart"></i> Comparte con respeto y cariño</span>
          <div class="ig-compose-footer-buttons">
            <button type="button" class="btn ig-compose-cancel" (click)="cancelarPublicacion()">Cancelar</button>
            <button type="button" class="btn ig-compose-submit" (click)="publicarPost()"><i class="fa-solid fa-paper-plane me-2"></i>{{ muro.rs_id == 0 ? 'Publicar' : 'Guardar cambios' }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Botón de acción-->
  <div *ngIf="!muro.showeditar && muro.rs_id != 0" class="row ig-post-actions mt-2 mb-2 align-items-center" [class.ig-actions-nested]="muro.nivel > 0" [class.disabled-div]="misdatos.rol == 'no_publico'">
    <!--Comentar-->
    <div class="col-auto mb-2" *ngIf="muro.rs_alcance != '1'">
      <a class="custom-link" (click)="comentarPublicacion()" title="Comentar">{{muro?.totalcomentarios > 0 ? muro?.totalcomentarios : ''}} <i class="fa-regular fa-comment"></i></a>
    </div>
    <!--Paseo: me apunto-->
    <div class="col-auto mb-2" *ngIf="muro.nivel == 0 && muro.rs_alcance != '1' && muro.rs_tipo_publicacion == '01' && !$any(muro).paseo_finalizado">
      <a class="custom-link" (click)="meApunto()" title="Me apunto al paseo" *ngIf="!muro.miparticipacionpaseo"><i class="fa-regular fa-thumbs-up"></i> Me apunto</a>
      <a class="custom-link is-done" (click)="meApunto()" title="Me apunto al paseo" *ngIf="muro.miparticipacionpaseo"><i class="fa-solid fa-thumbs-up"></i> Ya estoy apuntado</a>
    </div>
    <div class="col-auto mb-2" *ngIf="muro.nivel == 0 && muro.rs_tipo_publicacion == '01' && $any(muro).paseo_finalizado">
      <button type="button" class="ig-memory-btn" (click)="abrirAlbumPaseo()" title="Ver fotos compartidas del paseo">
        <i class="fa-regular fa-images" aria-hidden="true"></i> Recuerdos
      </button>
    </div>
    <!--Huellas-->
    <div class="col-auto mb-2" *ngIf="muro.rs_alcance != '1'">
      <a *ngIf="muro.rs_us_id == misdatos?.ID" class="me-2" [class.text-iguau]="muro.huellas > 0" [class.text-secondary]="muro.huellas == 0" title="Huellas">{{muro.huellas}} <i class="fa-solid fa-paw"></i></a>
      <a *ngIf="muro.rs_us_id != misdatos?.ID" class="custom-link pointer me-1" [class.text-iguau]="muro.mihuella > 0" [class.text-secondary]="muro.mihuella == 0" (click)="dejarHuella()" title="Huellas">{{muro.huellas}} <i class="fa-solid fa-paw"></i></a>

    </div>
    <!-- Denuncia: icono discreto; formulario modal accesible mediante SweetAlert2 -->
    <div class="col-auto mb-2" *ngIf="muro.rs_us_id != misdatos?.ID">
      <button type="button" class="ig-action-link ig-report-icon" (click)="abrirModalDenuncia()"
              [disabled]="enviandoReporte" [attr.aria-label]="muro.nivel > 0 ? 'Denunciar comentario' : 'Denunciar publicación'"
              [title]="muro.nivel > 0 ? 'Denunciar comentario' : 'Denunciar publicación'">
        <i class="fa-regular fa-flag" aria-hidden="true"></i>
      </button>
    </div>
    <!--Opciones-->
    <div class="col-auto mb-2 ig-owner-action" *ngIf="muro.rs_us_id == misdatos?.ID">
      <a class="custom-link" (click)="editarPublicacion()" title="Editar comentario"><i class="fa-solid fa-pencil small"></i></a>
    </div>
    <div class="col-auto mb-2 ig-owner-action" *ngIf="muro.rs_us_id == misdatos?.ID">
      <a class="custom-link" (click)="borrarPublicacion()" title="Borrar comentario"><i class="fa-solid fa-trash small"></i></a>
    </div>
    <div class="col-auto ig-huella-usuarios" *ngIf="muro?.usuarioshuella?.length > 0">
      <span class="pointer" data-bs-toggle="modal" data-bs-target="#huellasModal" [attr.data-id]="muro.rs_id">
        <span class="small me-1">Han dejado huella</span>
        <span class="small" *ngFor="let usuariohuella of muro?.usuarioshuella">
          <img
            *ngIf="usuariohuella?.foto_principal_thumb"
            [src]="usuariohuella?.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
            class="rounded-circle"
            width="25px">
          {{usuariohuella.first_name | firstWord}}
        </span>
        <span class="small me-1" *ngIf="muro.huellas > 2">y {{muro.huellas - 2}} persona<span *ngIf="muro.huellas - 2 > 1">s</span> más</span>
      </span>
    </div>
    <!--<div class="col text-end" *ngIf="muro.rs_us_id == misdatos?.ID">
      <div class="dropdown">
        <a class="custom-link pointer" data-bs-toggle="dropdown" aria-expanded="false"><i class="small fa-solid fa-ellipsis-vertical"></i></a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item pointer" (click)="editarPublicacion()" title="Editar comentario"><i class="fa-solid fa-pencil small"></i> Editar</a></li>
          <li><a class="dropdown-item pointer" (click)="borrarPublicacion()" title="Borrar comentario"><i class="fa-solid fa-trash small"></i> Borrar</a></li>
        </ul>
      </div>      
    </div>-->
  </div>
</div>

<input
  type="file"
  multiple
  #fileInputRedSocial
  accept="image/*"
  style="display: none"
  (change)="onFileSelected($event)"
/>

<!-- Álbum de recuerdos: fotos de la publicación y conversación -->
<div class="ig-album-overlay" *ngIf="albumAbierto" (click)="cerrarAlbumPaseo()" role="presentation">
  <section class="ig-album-dialog" role="dialog" aria-modal="true" aria-label="Recuerdos del paseo" (click)="$event.stopPropagation()">
    <header class="ig-album-heading"><div><h3>Recuerdos del paseo</h3><p>Fotos que ha compartido la comunidad</p></div>
      <button type="button" (click)="cerrarAlbumPaseo()" aria-label="Cerrar álbum"><i class="fa-solid fa-xmark"></i></button>
    </header>
    <p class="ig-album-empty" *ngIf="albumCargando">Cargando recuerdos…</p>
    <p class="ig-album-empty" *ngIf="!albumCargando && !albumFotos.length">Todavía no hay fotografías. Comparte tus recuerdos en los comentarios del paseo.</p>
    <div class="ig-album-grid" *ngIf="albumFotos.length">
      <a *ngFor="let foto of albumFotos" [href]="foto.foto_grande" target="_blank" rel="noopener noreferrer" [title]="'Foto de ' + foto.autor">
        <img [src]="foto.foto_thumb || foto.foto_grande" [alt]="'Fotografía compartida por ' + foto.autor" loading="lazy" />
        <span>{{foto.autor}}</span>
      </a>
    </div>
    <div class="ig-album-footer">Para añadir fotos, abre la conversación y compártelas en una publicación o respuesta.</div>
  </section>
</div>
